import PropTypes from 'prop-types'
import * as React from 'react'
import ReactDOM from 'react-dom'

import {cloneCreateOrCallChildren, pickAndMergeProps} from '@base/react-utils'

/** Captures mouse events on higher layer */
const eventCapture = (events, defaultProps = {}) =>
  class EventCapture extends React.PureComponent {
    static propTypes = {
      children: PropTypes.node.isRequired,
      outsideOnly: PropTypes.bool,
      stopPropagation: PropTypes.bool,
      preventDefault: PropTypes.bool,
      // Returning anything from onEvent will cancel event handling (stopPropagation or preventDefault)
      onEvent: PropTypes.func,
      onClick: PropTypes.func,
    }

    static defaultProps = defaultProps

    constructor(props) {
      super(props)
      this.handleEvent = this.handleEvent.bind(this)
    }

    componentDidMount() {
      events.forEach((event) =>
        window.addEventListener(event, this.handleEvent, true)
      )
    }

    componentWillUnmount() {
      events.forEach((event) =>
        window.removeEventListener(event, this.handleEvent, true)
      )
    }

    handleEvent(event) {
      if (
        this.props.outsideOnly &&
        ReactDOM.findDOMNode(this).contains(event.target)
      )
        return

      if (this.props.onEvent && this.props.onEvent(event) !== undefined) return

      const handler = this.props[EventCapture.eventMap[event.type]]
      if (handler && handler(event) !== undefined) return
      if (this.props.stopPropagation) event.stopPropagation()
      if (this.props.preventDefault) event.preventDefault()
    }

    static eventMap = {
      click: 'onClick',
      mousedown: 'onMouseDown',
      keydown: 'onKeyDown',
    }

    render() {
      return cloneCreateOrCallChildren(
        this.props.children,
        pickAndMergeProps(this.props, ['className', 'style', /^data-/])
      )
    }
  }

export default eventCapture

export class OutsideClickCapture extends eventCapture(['mousedown'], {
  outsideOnly: true,
  preventDefault: false,
  stopPropagation: false,
}) {}
